<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition-upper', 'pa-connection-add-cofirm-modal']"
   :additionalZIndex="2"
   :isOpen="isCharacterConfirmModalOpen"
   :position="{top: .1}"
   :isFreez="isFreezModal"
   contentTransitionName="trans-content"

   @closeOverlayModal="handleCloseOverlay"
  >
    <PaWideModalBox
     :confirmButtonText="'続ける'"
     :isSubmitLoading="characterConfirmModalSubmitLoading"
     :isDisabledSubmit="isDisabledSubmitButton"
     :character="selectedCharacter"
     @handleSubmit="handleClickSubmitButton"
     @handleCancel="handleClickCancelButton"
    >
      <template v-slot:title>マイポットに投入する</template>
      <template v-slot:description>「{{selectedCharacter.displayname}}」さんをマイポット「{{podRoom.name}}」に投入します。この処理には「きびだんご」が【１つ】必要です。</template>
      <template v-slot:caption>マイポットの投入には相手の承認は発生しません。相手を追加してその人がマイポットから抜けた場合でも「きびだんご」は返却されません。</template>
    </PaWideModalBox>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PaWideModalBox from '@/components/Parts/PAWideModalBox/PAWideModalBox.vue'

export default {
  components : {
    PaOverlayModal,
    PaWideModalBox
  },

  data(){
    return {
      isFreezModal              : false,

      isSubmitLoading           : false,
      isDisabledSubmitButton    : false,

      podRoomName               : null,
    };
  },

  computed : {
    podRoom(){
      return this.$store.state.connectionManageModal.podRoom;
    },

    selectedCharacter(){
      return this.$store.state.connectionManageModal.character;
    },

    isCharacterConfirmModalOpen(){
      return this.$store.state.connectionManageModal.isCharacterConfirmModalOpen;
    },

    characterConfirmModalSubmitLoading(){
      return this.$store.state.connectionManageModal.characterConfirmModalSubmitLoading;
    }
  },

  // watch : {
  //   isModalOpen(value){
  //     console.log('ANG');
  //     console.log(value);
  //   },
  //   podRoom(data){
  //     console.log('gao');
  //     console.log(data);
  //   }
  // },

  methods : {
    closeModal(){
      this.$store.dispatch({
        type  : 'connectionManageModal/updateCharacterConfirmModal',
        value : false,
      });
    },

    handleCloseOverlay(){
      this.closeModal();
    },

    handleClickSubmitButton(){
      this.$emit('clickSubmit');
    },

    handleClickCancelButton(){
      this.closeModal();
    }
  },
}
</script>